import { EXPLORER_DATA_GRID_COLUMN_VISIBILITY_MODEL } from "@/enum/cookie.name.enum.ts";
import { GridColumnVisibilityModel } from "@mui/x-data-grid-pro";
import { useCookies } from "react-cookie";
import { DEFAULT_EXPLORER_DATA_GRID_COLUMN_VISIBILITY_MODEL } from "@/features/Explorer/ExplorerContentColumns.tsx";

function useExplorerDataGridColumnVisibilityModel(): [GridColumnVisibilityModel, (newValue: GridColumnVisibilityModel) => void] {
  const [cookies, setCookie] = useCookies([EXPLORER_DATA_GRID_COLUMN_VISIBILITY_MODEL]);

  const handleSet = (newMode: GridColumnVisibilityModel) => {
    setCookie(EXPLORER_DATA_GRID_COLUMN_VISIBILITY_MODEL, newMode);
  }

  return [
    cookies.explorerDataGridColumnVisibilityModel || DEFAULT_EXPLORER_DATA_GRID_COLUMN_VISIBILITY_MODEL,
    handleSet
  ];
}

export default useExplorerDataGridColumnVisibilityModel;
